import { render, staticRenderFns } from "./autoSetting.vue?vue&type=template&id=5db5469e&"
import script from "./autoSetting.vue?vue&type=script&lang=js&"
export * from "./autoSetting.vue?vue&type=script&lang=js&"
import style0 from "./autoSetting.vue?vue&type=style&index=0&id=5db5469e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports